import it from './translation'
import { TEAM_ROLE_CODE_NAME } from "@/types/enum/storeEnum";

//Write here all the changes to translations that are not correct
it.label.teamRoleShort[TEAM_ROLE_CODE_NAME.ADMIN] = 'Admin'
it.messages.team.management.members = 'Membri della squadra di {location}'
it.label.permission.promotion = '@:object.promotion'
it.label.permission.message = '@:object.message'
it.label.loading.location = '@:object.location'
it.messages.order.orderProducts = 'I vostri ordini @:object.product'
it.messages.deliverer.addDeliverer = 'Aggiungere un @:object.deliverer'
it.object.message = 'messaggio | messaggi'
it.messages.dashboard.home.orders = 'ultimi ordini'
it.messages.order.currentOrders = 'ultimi ordini'
it.label.day = 'Giorno'
it.messages.cart.amountItems = "{amount} singolo articolo"
it.messages.cart.amount = "{amount} Posizioni degli articoli"
export default it
